
import axios from '@/axios.js'
import url from '@/url.js'

export default { 
  getSubKategori({}, params = {}) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))

      const conn = {
        method: 'get',
        url: `${url.base}/sub/kategori-campaign`,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        },
        params
      }

      axios(conn)
      .then(res => {
        let result = res.data
        if(result.data) {
          result.data.forEach(item => item.label = item.name)
        }

        resolve(result.data)
      })
      .catch(e => reject(e))
    })
  },
  getKategori({}, params = {}) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))

      const conn = {
        method: 'get',
        url: `${url.base}/kategori-campaign`,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        },
        params
      }

      axios(conn)
      .then(res => {
        let result = res.data
        if(result.data) {
          result.data.map(item => item.label = item.name)
        }

        resolve(result.data)
      })
      .catch(e => reject(e))
    })
  },
  getDetail({commit}, id) {
    return new Promise((resolve, reject) => {
      
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))

      const conn = {
        method: 'get',
        url: `${url.base}/campaign/${id}`,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }

      axios(conn).then(res => {
        let result = res.data
        if(result.kategori) {
          result.kategori.label = result.kategori.name
          if(result.kategori.kategori) {
            result.kategori.kategori.label = result.kategori.kategori.name
          }
        }
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDetailCampaign({}, payload){
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const conn = {
        method: 'get',
        url: `${url.base}/campaign/${payload}`,
        params: Object.assign(payload),
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  getCampaign({commit}, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const ord = {
        ord: "desc",
      }
      const conn = {
        method: 'get',
        url: `${url.base}/campaign`,
        params: Object.assign(payload, ord),
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        let result = res.data.data
        commit('SET_TOTAL', res.data.recordsTotal)
        commit('SET_DATA_CAMPAIGN', result)
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  getSubKatCampaign({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const ord = {
        ord: "desc"
      }
      const conn = {
        method: 'get',
        url: `${url.base}/sub/kategori-campaign`,
        params: Object.assign(payload, ord),
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        let result = res.data.data
        commit('SET_SUB_KAT_TOTAL', res.data.recordsTotal)
        commit('SET_SUB_KATEGORI_LIST', result)
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  getKatCampaign({commit}, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const ord = {
        ord: "desc"
      }
      const conn = {
        method: 'get',
        url: `${url.base}/kategori-campaign`,
        params: Object.assign(payload, ord),
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        let result = res.data.data
        commit('SET_KAT_TOTAL', res.data.recordsTotal)
        commit('SET_KATEGORI_LIST', result)
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  cudSubKatCampaign({ }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const conn = {
        method: 'post',
        url: `${url.base}/input/sub/kategori-campaign`,
        data: payload,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  cudKatCampaign({ }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const conn = {
        method: 'post',
        url: `${url.base}/input/kategori-campaign`,
        data: payload,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  cudCampaign({ }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const conn = {
        method: 'post',
        url: `${url.base}/input/campaign`,
        data: payload,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  
}
